<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
      clipped-left
    >
      <v-app-bar-nav-icon @click.stop="navigation = !navigation"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $t('header.apptitle') }} <small>({{ frontendVersion }})</small></v-toolbar-title>
      <v-spacer></v-spacer>
      <locale-changer-button/>
    </v-app-bar>

    <v-navigation-drawer
      v-model="navigation"
      :mini-variant="mini"
      app
      clipped
    >
      <v-list>
        <v-subheader class="px-2">
          <v-list-item-title
            v-if="!mini"
            class="pl-3"
          >{{ $t('Navigation') }}</v-list-item-title>
          <v-btn
            icon
            @click.stop="mini = !mini"
          >
            <v-icon v-if="mini">mdi-chevron-right</v-icon>
            <v-icon v-else>mdi-chevron-left</v-icon>
          </v-btn>
        </v-subheader>
        <v-list-item
          class="px-2"
          to="/"
        >
          <v-list-item-avatar>
            <v-icon>mdi-home</v-icon>
          </v-list-item-avatar>
          <v-list-item-title>
            {{ $t('nav.home') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          class="px-2"
          disabled
        >
          <v-list-item-avatar>
            <v-icon>mdi-information</v-icon>
          </v-list-item-avatar>
          <v-list-item-title>
            {{ $t('nav.about') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          class="px-2"
          disabled
        >
          <v-list-item-avatar>
            <v-icon>mdi-security</v-icon>
          </v-list-item-avatar>
          <v-list-item-title>
            {{ $t('nav.privacy') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <status/>
    </v-navigation-drawer>

    <v-main>
      <router-view/>
    </v-main>

  </v-app>
</template>

<script>
import Status from '@/components/Status'
import LocaleChangerButton from '@/components/LocaleChangerButton'
import {version} from '../package.json'

export default {
  name: 'App',

  components: {
    Status,
    LocaleChangerButton
  },

  data: () => ({
    navigation: true,
    mini: true,
    frontendVersion: version
  })
}
</script>
